import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { RcentNewsCard, Skeleton } from '../../../../component';
import { NewsPaperIcon } from '../../../../content/svg-component';

function RecentNews({ newsData, loadingData, language }) {
  const loadingNewsLst = [...Array(5).keys()];
  return (
    <div
      className={`col-lg-4 col-12 px-lg-0 px-2 d-flex align-items-center justify-content-center pt-lg-0 pt-4`}
    >
      <div className="d-flex flex-row justify-content-center default-border-radius-small w-100 h-100 px-0 px-md-1 px-lg-0">
        <div className="default-border-radius-small col-lg-11 w-100 bg-white border border-third-light h-100 px-3 py-4">
          <div className="d-flex flex-column align-items-start">
            <FormattedMessage id="profile.recentNews" />
            <span className="text-third font-md-xsmall font-smaller pb-3 pt-2">
              <FormattedMessage id="profile.tourismNews" />
            </span>
          </div>
          <div className="overflow-auto" style={{ height: '17rem' }}>
            {newsData.length > 0 ? (
              newsData.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <RcentNewsCard
                      newsData={item}
                      language={language}
                      index={index}
                    />
                  </React.Fragment>
                );
              })
            ) : loadingData ? (
              loadingNewsLst.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div className="d-flex col-12 flex-row justify-content-start align-items-center mb-3">
                      <div className="d-flex flex-row col-lg-3 col-2 px-0">
                        <Skeleton
                          variant={'squre'}
                          height={'2rem'}
                          className="w-100 border rounded"
                        />
                      </div>
                      <div
                        className={`d-flex flex-column px-2 col-md-9 col-10`}
                      >
                        <Skeleton variant={'text'} className="w-100" />
                        <div className="text-third font-xl-msmall font-lg-smaller font-msmall w-100 mt-2">
                          <Skeleton variant={'text'} className="w-100" />
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })
            ) : (
              <div className="h-100 d-flex flex-column justify-content-center align-items-center">
                <NewsPaperIcon size={36} color={'#aaacaf'} />
                <span className="pt-2 text-third">
                  <FormattedMessage id="profile.notfoundnews" />
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

RecentNews.propTypes = {};
function mapStateToProps(state, props) {
  return {
    language: state.language,
    user: state?.user?.userInfo,
  };
}
export default injectIntl(RecentNews);
